// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#partInformationModal .modal-dialog {
    overflow-y: initial!important
}

#partInformationModal .modal-body {
    padding: 0;
    max-height: 85vh;
    overflow-y: auto;
    overflow-x: hidden;
}

#partInformationModal .basic-info {
    font-size: 14px;
    padding: 0;
    border: 1px solid #D8D8D8;
}

#partInformationModal .basic-info .basic-info-content {
        padding: 1em;
 }

    #partInformationModal .basic-info .basic-info-content-with-scrolled {
        padding: 1em;
        overflow-y: scroll;
    }

#partInformationModal .basic-info .fixed-height {
    height: 228px;
}

#partInformationModal .basic-info .title {
        text-align: left;
        padding-left: 15px;
}

#partInformationModal .basic-info .align-left {
        text-align: left;
}

    #partInformationModal .basic-info h5 {
        color: #FF6D37;
        font-size: 1rem;
        background-color: #EBEBEB;
        border-bottom: 1px solid #D8D8D8;
    }

#partInformationModal .basic-info h5 i {
    color: #666;
    font-size: 1em;
    margin-bottom: 2px;
    margin-left: 5px;
}

#partInformationModal .basic-info h5 i:hover{
    cursor: help;
}

.help {
        cursor: help;
    }

.oem-help-icon {
    font-size: 1.1em;
    align-self: center;
    margin-left: 3px;
}

#partInformationModal .basic-info .row, .basic-info h5 {
    padding: .25em;
}

#partInformationModal .basic-info .data-header {
    font-weight: bold;
    color: #355D67;
}

#partInformationModal .basic-info .data {
    font-weight: normal;
    color: #000;
}

#partInformationModal .basic-info .alignment {
        display: flex;
}

#partInformationModal .basic-info .margin-left {
        margin-left: 4px;
        
}

#partInformationModal .padding{
       padding: 5px;
}

#partInformationModal .basic-info p {
    margin-bottom: 0;
}

#partInformationModal .basic-info .addNote {
    font-size: 125%;
    margin-bottom: 3px;
    margin-left: 5px;
    color: limegreen;
}

#partInformationModal .basic-info .addNote:hover {
    cursor: pointer;
}

#partInformationModal .save-close {
    position: absolute;
    right: 40px;
    color: #6c757d;
    background: none;
    border: none;
    letter-spacing: .5px;
    font-weight: 500;
    font-size: 1em;
}

#partInformationModal .save-close:hover {
    color: #343a40;
    background: none;
}

#partInformationModal .internal-info {
    background-color: #d9d9d9;    
    border: 1px solid red;
}

#partInformationModal .current-part {
    color: #007bff;
}

#partInformationModal .internal-info td, #partInformationModal .internal-info th {
    font-weight: 700;
    border: 1px solid #888;    
}

#partInformationModal .internal-info td {
    background-color: white;
}

#partInformationModal .react-bootstrap-table {
    margin-bottom: 1em;
}

#partInformationModal .react-bootstrap-table table {
    margin-bottom: 0;
}

#partInformationModal #daysTable th:last-child {
    width: 40%;
}

#partInformationModal #partChangeHistory th:nth-child(3),
#partInformationModal #partChangeHistory th:nth-child(4) {
    width: 12%;
}

#partInformationModal #partChangeHistory td:nth-child(2),
#partInformationModal #partChangeHistory td:nth-child(3),
#partInformationModal #partChangeHistory td:nth-child(4),
#partInformationModal #partChangeHistory td:nth-child(5) {
    text-align: right;
}

#partInformationModal #suggestionOrderReturnHistory td:nth-child(4),
#partInformationModal #suggestionOrderReturnHistory td:nth-child(5) {
    text-align: right;
}
#partInformationModal #salesHistory td:nth-child(2),
#partInformationModal #salesHistory td:nth-child(3),
#partInformationModal #salesHistory td:nth-child(4),
#partInformationModal #salesHistory td:nth-child(5),
#partInformationModal #salesHistory td:nth-child(6),
#partInformationModal #salesHistory td:nth-child(7),
#partInformationModal #salesHistory td:nth-child(8),
#partInformationModal #salesHistory td:nth-child(9),
#partInformationModal #salesHistory td:nth-child(10),
#partInformationModal #salesHistory td:nth-child(11),
#partInformationModal #salesHistory td:nth-child(12),
#partInformationModal #salesHistory td:nth-child(13) {
    text-align: right;
}

.table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
    width: 16%;
}

#planningPara{
    text-align:left
}
#planningDays {
    text-align: left
}

#partInformationModal #salesHistory th:nth-child(2),
#partInformationModal #salesHistory th:nth-child(3),
#partInformationModal #salesHistory th:nth-child(4),
#partInformationModal #salesHistory th:nth-child(5),
#partInformationModal #salesHistory th:nth-child(6),
#partInformationModal #salesHistory th:nth-child(7),
#partInformationModal #salesHistory th:nth-child(8),
#partInformationModal #salesHistory th:nth-child(9),
#partInformationModal #salesHistory th:nth-child(10),
#partInformationModal #salesHistory th:nth-child(11),
#partInformationModal #salesHistory th:nth-child(12),
#partInformationModal #salesHistory th:nth-child(13) {
    width: 7.8%;
}

.table .thead-light th {
    color: #495057;
    background-color: #e9ecef;
    border-color: #dee2e6;
    width: 16%;
}

#planningPara {
    text-align: left
}

#planningDays {
    text-align: left
}

#partInformationModal #paramTable .thead-light th:nth-child(15) {
    width: 40%;
}
`, "",{"version":3,"sources":["webpack://./src/Shared/PartInformationModal/PartInformationModal.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,yBAAyB;AAC7B;;AAEA;QACQ,YAAY;CACnB;;IAEG;QACI,YAAY;QACZ,kBAAkB;IACtB;;AAEJ;IACI,aAAa;AACjB;;AAEA;QACQ,gBAAgB;QAChB,kBAAkB;AAC1B;;AAEA;QACQ,gBAAgB;AACxB;;IAEI;QACI,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,gCAAgC;IACpC;;AAEJ;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;QACQ,YAAY;IAChB;;AAEJ;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;QACQ,aAAa;AACrB;;AAEA;QACQ,gBAAgB;;AAExB;;AAEA;OACO,YAAY;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,UAAU;AACd;;AAEA;;;;IAII,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;AACrB;AACA;;;;;;;;;;;;IAYI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI;AACJ;AACA;IACI;AACJ;;AAEA;;;;;;;;;;;;IAYI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;AACd","sourcesContent":["#partInformationModal .modal-dialog {\r\n    overflow-y: initial!important\r\n}\r\n\r\n#partInformationModal .modal-body {\r\n    padding: 0;\r\n    max-height: 85vh;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n}\r\n\r\n#partInformationModal .basic-info {\r\n    font-size: 14px;\r\n    padding: 0;\r\n    border: 1px solid #D8D8D8;\r\n}\r\n\r\n#partInformationModal .basic-info .basic-info-content {\r\n        padding: 1em;\r\n }\r\n\r\n    #partInformationModal .basic-info .basic-info-content-with-scrolled {\r\n        padding: 1em;\r\n        overflow-y: scroll;\r\n    }\r\n\r\n#partInformationModal .basic-info .fixed-height {\r\n    height: 228px;\r\n}\r\n\r\n#partInformationModal .basic-info .title {\r\n        text-align: left;\r\n        padding-left: 15px;\r\n}\r\n\r\n#partInformationModal .basic-info .align-left {\r\n        text-align: left;\r\n}\r\n\r\n    #partInformationModal .basic-info h5 {\r\n        color: #FF6D37;\r\n        font-size: 1rem;\r\n        background-color: #EBEBEB;\r\n        border-bottom: 1px solid #D8D8D8;\r\n    }\r\n\r\n#partInformationModal .basic-info h5 i {\r\n    color: #666;\r\n    font-size: 1em;\r\n    margin-bottom: 2px;\r\n    margin-left: 5px;\r\n}\r\n\r\n#partInformationModal .basic-info h5 i:hover{\r\n    cursor: help;\r\n}\r\n\r\n.help {\r\n        cursor: help;\r\n    }\r\n\r\n.oem-help-icon {\r\n    font-size: 1.1em;\r\n    align-self: center;\r\n    margin-left: 3px;\r\n}\r\n\r\n#partInformationModal .basic-info .row, .basic-info h5 {\r\n    padding: .25em;\r\n}\r\n\r\n#partInformationModal .basic-info .data-header {\r\n    font-weight: bold;\r\n    color: #355D67;\r\n}\r\n\r\n#partInformationModal .basic-info .data {\r\n    font-weight: normal;\r\n    color: #000;\r\n}\r\n\r\n#partInformationModal .basic-info .alignment {\r\n        display: flex;\r\n}\r\n\r\n#partInformationModal .basic-info .margin-left {\r\n        margin-left: 4px;\r\n        \r\n}\r\n\r\n#partInformationModal .padding{\r\n       padding: 5px;\r\n}\r\n\r\n#partInformationModal .basic-info p {\r\n    margin-bottom: 0;\r\n}\r\n\r\n#partInformationModal .basic-info .addNote {\r\n    font-size: 125%;\r\n    margin-bottom: 3px;\r\n    margin-left: 5px;\r\n    color: limegreen;\r\n}\r\n\r\n#partInformationModal .basic-info .addNote:hover {\r\n    cursor: pointer;\r\n}\r\n\r\n#partInformationModal .save-close {\r\n    position: absolute;\r\n    right: 40px;\r\n    color: #6c757d;\r\n    background: none;\r\n    border: none;\r\n    letter-spacing: .5px;\r\n    font-weight: 500;\r\n    font-size: 1em;\r\n}\r\n\r\n#partInformationModal .save-close:hover {\r\n    color: #343a40;\r\n    background: none;\r\n}\r\n\r\n#partInformationModal .internal-info {\r\n    background-color: #d9d9d9;    \r\n    border: 1px solid red;\r\n}\r\n\r\n#partInformationModal .current-part {\r\n    color: #007bff;\r\n}\r\n\r\n#partInformationModal .internal-info td, #partInformationModal .internal-info th {\r\n    font-weight: 700;\r\n    border: 1px solid #888;    \r\n}\r\n\r\n#partInformationModal .internal-info td {\r\n    background-color: white;\r\n}\r\n\r\n#partInformationModal .react-bootstrap-table {\r\n    margin-bottom: 1em;\r\n}\r\n\r\n#partInformationModal .react-bootstrap-table table {\r\n    margin-bottom: 0;\r\n}\r\n\r\n#partInformationModal #daysTable th:last-child {\r\n    width: 40%;\r\n}\r\n\r\n#partInformationModal #partChangeHistory th:nth-child(3),\r\n#partInformationModal #partChangeHistory th:nth-child(4) {\r\n    width: 12%;\r\n}\r\n\r\n#partInformationModal #partChangeHistory td:nth-child(2),\r\n#partInformationModal #partChangeHistory td:nth-child(3),\r\n#partInformationModal #partChangeHistory td:nth-child(4),\r\n#partInformationModal #partChangeHistory td:nth-child(5) {\r\n    text-align: right;\r\n}\r\n\r\n#partInformationModal #suggestionOrderReturnHistory td:nth-child(4),\r\n#partInformationModal #suggestionOrderReturnHistory td:nth-child(5) {\r\n    text-align: right;\r\n}\r\n#partInformationModal #salesHistory td:nth-child(2),\r\n#partInformationModal #salesHistory td:nth-child(3),\r\n#partInformationModal #salesHistory td:nth-child(4),\r\n#partInformationModal #salesHistory td:nth-child(5),\r\n#partInformationModal #salesHistory td:nth-child(6),\r\n#partInformationModal #salesHistory td:nth-child(7),\r\n#partInformationModal #salesHistory td:nth-child(8),\r\n#partInformationModal #salesHistory td:nth-child(9),\r\n#partInformationModal #salesHistory td:nth-child(10),\r\n#partInformationModal #salesHistory td:nth-child(11),\r\n#partInformationModal #salesHistory td:nth-child(12),\r\n#partInformationModal #salesHistory td:nth-child(13) {\r\n    text-align: right;\r\n}\r\n\r\n.table .thead-light th {\r\n    color: #495057;\r\n    background-color: #e9ecef;\r\n    border-color: #dee2e6;\r\n    width: 16%;\r\n}\r\n\r\n#planningPara{\r\n    text-align:left\r\n}\r\n#planningDays {\r\n    text-align: left\r\n}\r\n\r\n#partInformationModal #salesHistory th:nth-child(2),\r\n#partInformationModal #salesHistory th:nth-child(3),\r\n#partInformationModal #salesHistory th:nth-child(4),\r\n#partInformationModal #salesHistory th:nth-child(5),\r\n#partInformationModal #salesHistory th:nth-child(6),\r\n#partInformationModal #salesHistory th:nth-child(7),\r\n#partInformationModal #salesHistory th:nth-child(8),\r\n#partInformationModal #salesHistory th:nth-child(9),\r\n#partInformationModal #salesHistory th:nth-child(10),\r\n#partInformationModal #salesHistory th:nth-child(11),\r\n#partInformationModal #salesHistory th:nth-child(12),\r\n#partInformationModal #salesHistory th:nth-child(13) {\r\n    width: 7.8%;\r\n}\r\n\r\n.table .thead-light th {\r\n    color: #495057;\r\n    background-color: #e9ecef;\r\n    border-color: #dee2e6;\r\n    width: 16%;\r\n}\r\n\r\n#planningPara {\r\n    text-align: left\r\n}\r\n\r\n#planningDays {\r\n    text-align: left\r\n}\r\n\r\n#partInformationModal #paramTable .thead-light th:nth-child(15) {\r\n    width: 40%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
